import * as React from 'react'

import { useBgColorCtx } from '~theme/BgColorProvider'

import { Pictogram, TPictogramProps } from './Pictogram'
import { getPictogramForIcon, TPictogramIcon } from './pictograms'

type TProps = NoChildren &
  OmitSafe<TPictogramProps, 'pictogram' | 'color'> & {
    icon: TPictogramIcon
  }

/**
 * our custom icon font rendering component
 * wrapper around the Pictogram
 */
export const PictogramIcon: React.FC<TProps> = ({ icon, ...pictogramProps }) => {
  const pictogram = getPictogramForIcon(icon)
  const { fgColors } = useBgColorCtx()

  if (!pictogram) {
    return null
  }

  return <Pictogram {...pictogramProps} color={fgColors.normal} pictogram={pictogram} />
}
